import TemplateNames from './TemplateNames';

export default {
  title: 'Automatiske e-mails',
  labels: {
    empty_list: 'Ingen skabeloner fundet',
    load_failed: 'Dine automatiserede e-mails kunne ikke indlæses. Genindlæs siden, eller kontakt support.',
    on: 'Til',
    off: 'Fra',
  },
  fields: {
    name: 'Navn',
    messages_delivered: 'Leverede beskeder',
    open_rate: 'Åbningsrate',
    click_rate: 'Klikrate',
    status: 'Status',
  },
  template_names: TemplateNames,
  toasts: {
    failed_to_update_status: 'Status kunne ikke opdateres',
    failed_to_load_data: 'Data kunne ikke indlæses',
  },
};
